import { render, staticRenderFns } from "./AwardsSideInfo.vue?vue&type=template&id=2f5a6900&scoped=true"
import script from "./AwardsSideInfo.vue?vue&type=script&lang=js"
export * from "./AwardsSideInfo.vue?vue&type=script&lang=js"
import style0 from "./AwardsSideInfo.vue?vue&type=style&index=0&id=2f5a6900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a6900",
  null
  
)

/* custom blocks */
import block0 from "./AwardsSideInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports